<template>
  <div class="trip-list-view">
    <van-nav-bar title="旅行回憶" fixed>
      <template #right>
        <van-icon name="replay" @click="confirmReset" />
      </template>
    </van-nav-bar>

    <div class="page-wrap" style="padding-top: 66px;">
      <div v-if="trips.length" class="trips">
        <TripCard v-for="t in trips" :key="t.id" :trip="t" />
      </div>
      <div v-else class="empty-state">
        <span class="emoji">🧳</span>
        還沒有任何 Trip，建立你的第一趟旅程吧！
      </div>

      <div class="quick-actions">
        <van-button icon="plus" type="primary" block round @click="showCreate = true">建立 Trip</van-button>
        <van-button icon="clock-o" type="default" block round @click="quickStart">立即開始記錄（隨心遊）</van-button>
      </div>
    </div>

    <van-popup v-model="showCreate" position="bottom" round :style="{ maxHeight: '88%' }" closeable>
      <div class="popup-title">建立 Trip</div>
      <div class="popup-body">
        <TripForm @submit="onCreate" @cancel="showCreate = false" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Dialog, Toast } from 'vant'
import TripCard from '@/components/trip/TripCard.vue'
import TripForm from '@/components/trip/TripForm.vue'
import { CURRENT_USER_ID } from '@/mock/seed'

export default {
  name: 'TripListView',
  components: { TripCard, TripForm },
  data () {
    return {
      showCreate: false
    }
  },
  computed: {
    ...mapGetters({ trips: 'trip/all' })
  },
  methods: {
    ...mapActions({ createTrip: 'trip/createTrip' }),
    onCreate (form) {
      const id = this.createTrip({ ...form, ownerId: CURRENT_USER_ID, ownerName: '我' })
      this.showCreate = false
      Toast.success('Trip 建立成功')
      this.$router.push(`/trip/${id}/overview`)
    },
    quickStart () {
      const id = this.createTrip({
        name: `${new Date().getMonth() + 1}月${new Date().getDate()}日的旅行`,
        description: '',
        destinations: [],
        startDate: '',
        endDate: '',
        settlementCurrency: 'HKD',
        coverEmoji: '🎒',
        tags: [],
        quickStart: true,
        ownerId: CURRENT_USER_ID,
        ownerName: '我'
      })
      Toast.success('已開始記錄，馬上進入旅行中！')
      this.$router.push(`/trip/${id}/timeline`)
    },
    confirmReset () {
      Dialog.confirm({
        title: '重設示範資料',
        message: '會清除所有 demo 操作紀錄，恢復成初始的示範資料，確定嗎？'
      }).then(() => {
        this.$store.dispatch('resetDemoData')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.quick-actions {
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.popup-title {
  padding: 16px;
  font-weight: 700;
  font-size: 16px;
  border-bottom: 1px solid var(--color-border);
}
.popup-body {
  padding-bottom: 12px;
}
</style>
